import { atom, selector, useRecoilCallback } from 'recoil';
import { recoilPersist } from 'recoil-persist'
import { v4 as uuidv4 } from 'uuid';

const { persistAtom } = recoilPersist()

export const defaultTriggerItem = {
    name: 'TRIGGER',
    action_name: 'TRIGGER',
    id: uuidv4(),
    type: 'standard',
    hidden: false,
    libraryName: 'TRIGGER-STATIC',
    libraryLabel: 'TRIGGERSTATIC',
    library_label: 'TRIGGERSTATIC',
    actionName: 'TRIGGER',
    isDebugging: false,
    library_name: 'TRIGGER-STATIC',
    fields: {}
}


export const defaultItems = [
    {
        name: 'START',
        action_name: 'START',
        id: uuidv4(),
        type: 'standard',
        hidden: false,
        libraryName: 'START',
        actionName: 'START'
    },
    {
        name: 'STOP',
        action_name: 'STOP',
        id: uuidv4(),
        item_id: uuidv4(),
        type: 'standard',
        hidden: false,
        libraryName: 'STOP',
        actionName: 'STOP',
        isDebugging: false,
        libraryLabel: 'STOP',
        library_label: 'STOP',
        library_name: 'STOP',
        fields: {}
    }
]

export const defaultItemsForAction = [
    {
        name: 'START',
        action_name: 'START',
        id: uuidv4(),
        type: 'standard',
        hidden: false,
        libraryName: 'START',
        actionName: 'START'
    },
    {
        name: 'STOP',
        action_name: 'STOP',
        id: uuidv4(),
        type: 'standard',
        hidden: false,
        libraryName: 'STOP',
        actionName: 'STOP',
        isDebugging: false,
        libraryLabel: 'STOP',
        library_label: 'STOP',
        library_name: 'STOP',
        fields: {}
    }
]

export const defaultTriggerDetail = atom({
    key: "defaultTriggerDetail",
    default: {
        trigger_type: "",
        integration_type: ""
    }

})

export const openDesktopRecordAtom = atom({
    key: "defaultOpenDesktopRecord",
    default: false

})
export const scopedImageAtom = atom({
    key: "scopedImageAtom",
    default: ""
})

// export const activeAutom = atom({
//     key: 'activeAutom',
//     default: {
//         name: '',
//         mate_id: null,
//         history: [],
//         activeItem: [],
//         items: defaultItems
//     }
// })
export const activeAutom = atom({
    key: 'activeAutom',
    default: {
        name: '',
        mate_id: null,
        history: [],
        items: defaultItems
    }
})
export const errorHandlingActiveAutom = atom({
    key: 'errorHandlingActiveAutom',
    default: {
        name: '',
        mate_id: null,
        history: [],
        items: defaultItems
    }
})
export const errorHandlingAutom = atom({
    key: 'errorHandlingAutom',
    default: []
})

export const activeItemsAtom = atom({
    key: "activeItems",
    default: []
})
export const desktopActiveItemsAtom = atom({
    key: "desktopActiveItemsAtom",
    default: []
})
export const itemExpand = atom({
    key: "itemExpand",
    default: {}
})
export const copiedItemState = atom({
    key: "copiedItemState",
    default: {}
})

export const renameTime = atom({
    key: 'renameTime',
    default: new Date()
})

export const browserTabId = atom({
    key: 'browserTabId',
    default: null
})

export const saveAvailable = atom({
    key: 'saveAvailable',
    default: false
})

export const initialActions = atom({
    key: 'initialActions',
    default: {}
})

export const changedFields = atom({
    key: 'changedFields',
    default: {}
})
export const outNewValueAtom = atom({
    key: 'outNewValueAtom',
    default: { isOk: false, value: "" }
})

export const activeTab = atom({
    key: 'activeTab',
    default: 0,
    effects_UNSTABLE: [persistAtom]
})

export const activeUser = atom({
    key: 'activeUser',
    default: '',
    effects_UNSTABLE: [persistAtom],
})

export const unreadNotificationCount = atom({
    key: 'unreadNotificationCount',
    default: 0
})

export const oauthState = atom({
    key: 'oauthState',
    default: new Date()
})


export const activeSideBarMenu = atom({
    key: 'activeSideBarMenu',
    default: {
        parent: 0,
        child: 0,
        thirdChild: 0
    }
})
export const openListState = atom({
    key: 'openListState',
    default: false
})
export const asmTempState = atom({
    key: 'asmTempState',
    default: {}
})

export const queueLog = atom({
    key: 'queueLog',
    default: false
})

export const debugList = atom({
    key: 'debugList',
    default: []
})

export const testAppLog = atom({
    key: 'testAppLog',
    default: {}
})

export const automList = atom({
    key: 'automList',
    default: []
})

export const alertState = atom({
    key: 'alertState',
    default: {
        show: false,
        message: '',
        severity: 'info',
        link: ""
    }
})

export const fieldPreviewData = atom({
    key: 'fieldPreviewData',
    default: {
        triggerData: {
            data: {
                field_path: {},
                ff_name_path: {}
            },
            inputs: {},
            inputConfigurations: [],
            error: ''
        }
    }
});

export const actionFieldPreviewData = atom({
    key: 'actionFieldPreviewData',
    default: {
        actionsData: []
    }
});

export const triggerSelection = atom({
    key: 'triggerSelection',
    default: []
});

export const triggerConf = atom({
    key: 'triggerConf',
    default: {
        app: {},
        trigger: {},
        connector: {},
        setup: {
            fields: {},
            conditions: [],
            inputs: {}
        }
    }
});

export const selectedField = atom({
    key: 'selectedField',
    default: {
        key: '',
        name: '',
        type: '',
        path: []
    }
});

export const lastFocusField = atom({
    key: 'lastFocusField',
    default: {
        inputName: '',
        type: ''
    }
});

export const inputRefresh = atom({
    key: 'inputRefresh',
    default: new Date()
});

export const licensePermission = atom({
    key: 'licensePermission',
    default: undefined
});

export const rolePermission = atom({
    key: 'rolePermission',
    default: undefined
});

export const personalizationState = atom({
    key: 'personalizationState',
    default: undefined
});
export const languageState = atom({
    key: 'languageState',
    default: "en-EN"
});

export const inProgressListState = selector({
    key: 'inProgressListState',
    get: ({ get }) => {
        return get(automList).filter(item => item.operation_status === 'IN-PROGRESS')
    }
})

export const pendingListState = selector({
    key: 'pendingListState',
    get: ({ get }) => {
        return get(automList).filter(item => item.operation_status === 'PENDING')
    }
})

export const doneListState = selector({
    key: 'doneListState',
    get: ({ get }) => {
        return get(automList).filter(item => item.operation_status !== 'IN-PROGRESS' && item.operation_status !== 'PENDING')
    }
})

export const showObjectExplorerIcon = atom({
    key: 'showObjectExplorerIcon',
    default: false
})

export const schedulerNexRunTimes = atom({
    key: 'schedulerNextRunTimes',
    default: []
})

export const openDebugRunning = atom({
    key: 'openDebugRunning',
    default: false
})

export const automModules = atom({
    key: 'automModules',
    default: []
});
export const quickActionsAtom = atom({
    key: 'quickActionsAtom',
    default: []
})
export const scopeLibraryAtom = atom({
    key: 'scopeLibraryAtom',
    default: { name: '', list: [], id: '' }
})

export const desktopActionWaitingList = atom({
    key: 'desktopActionWaitingList',
    default: {}
})

export const baseOrigin = atom({
    key: 'baseOrigin',
    default: ""
});

export const pulseEffect = atom({
    key: 'pulseEffect',
    default: true
});

export const atomSearchValue = atom({
    key: 'atomSearchValue',
    default: ""
});
export const currentPageAtom = atom({
    key: 'currentPageAtom',
    default: 1
});
export const itemsPerPageAtom = atom({
    key: 'itemsPerPageAtom',
    default: 8
});

export const operationLogsStatus = atom({
    key: 'operationLogsStatus',
    default: {}
})

// SELECTOR

//  ---------------1----------------

// export const itemsSelector = selector({
//     key: 'itemsSelector',
//     get: ({ get }) => {
//         const state = get(activeAutom);
//         return state.items;
//     },
//     set: ({ set }, newValue) => {
//         set(activeAutom, prevState => ({
//             ...prevState,
//             items: newValue,
//         }));
//     },
// });

//  ---------------2----------------

// export const itemsSelector = selector({
//     key: 'itemsSelector',
//     get: ({ get }) => {
//         return get(activeAutom); // Örnek olarak bir atom kullanıldı, uygun atom veya başka bir selector'u ekleyin.
//     },
// });

// export const setItemsSelector = selector({
//     key: 'setUserSelector',
//     get: ({ get }) => {
//         // Bu get fonksiyonu zorunlu, ancak burada gerekli değil, sadece dummy bir değer dönebilirsiniz.
//         return get(activeAutom);
//     },
//     set: ({ set }, newValue) => {
//         // Burada global state'i güncellemek için set işlemini gerçekleştirin
//         set(activeAutom, newValue);
//         // set(activeAutom, prevState => ({
//         //     ...prevState,
//         //     items: newValue,
//         // }));
//     },
// });

// export const useSetItems = () => {
//     // useRecoilCallback kullanarak set işlemlerini gerçekleştiren bir hook oluşturun
//     return useRecoilCallback(({ set }) => (newValue) => {
//         set(setItemsSelector, newValue);
//     });
// };

//  ---------------3----------------

// const draggableItemsState = atom({
//     key: 'draggableItemsState',
//     default: {/* ... */ },
// });

// const orderState = atom({
//     key: 'orderState',
//     default: [],
// });

// const filteredDraggableItems = selector({
//     key: 'filteredDraggableItems',
//     get: ({ get }) => {
//         const allItems = get(draggableItemsState);
//         const order = get(orderState);
//         // Sadece sıralanan öğeleri içeren bir alt küme döndür
//         return order.map(itemId => allItems[itemId]);
//     },
// });

// export const useUpdateOrder = () => {
//     // useRecoilCallback kullanarak set işlemlerini gerçekleştiren bir hook oluşturun
//     return useRecoilCallback(({ set }) => (newValue) => {
//         set(orderState, newValue);
//     });
// };

